import { styled } from "@mui/system";
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import UploadButton from "./UploadButton";
import React, { Dispatch, FC, SetStateAction } from "react";
import DownloadVehiclesButton from "./DownloadVehiclesButton";
import { Box, Button, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExpandContainerButton from "../../../common/small-screen/ExpandContainerButton";
import { TableActions } from "../../../common/styles";
import { Link } from "react-router-dom";
import VehiclesTableToggle from "../VehiclesTableToggle";
import ResetColumnVisibilityButton from "../../table/ResetColumnVisibilityButton";

interface ToolbarProps {
  setFilterButtonEl: Dispatch<SetStateAction<HTMLButtonElement | null>>;
  setDisplayAll: Dispatch<SetStateAction<boolean>>;
  displayAll: boolean;
}

const Toolbar: FC<ToolbarProps> = ({
  setFilterButtonEl,
  displayAll,
  setDisplayAll,
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Box>
        <VehiclesTableToggle />
      </Box>
      <TableActions>
        <ResetColumnVisibilityButton />
        <GridToolbarFilterButton ref={setFilterButtonEl} />
        <UploadButton />
        <DownloadVehiclesButton />
        <Link to="/vehicles/create">
          <Tooltip title={t("vehicles.create.tooltip")}>
            <Button data-cy="create.vehicle" variant="contained">
              {t("vehicles.create")}
            </Button>
          </Tooltip>
        </Link>
        <ExpandContainerButton
          setDisplayAll={setDisplayAll}
          displayAll={displayAll}
        />
      </TableActions>
    </Wrapper>
  );
};

const Wrapper = styled(GridToolbarContainer)(({ theme }) => ({
  justifyContent: "space-between",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
  },
}));

export default Toolbar;
